import { render, staticRenderFns } from "./ApprovalFiles.vue?vue&type=template&id=03b5fdaf"
import script from "./ApprovalFiles.vue?vue&type=script&lang=js"
export * from "./ApprovalFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports